module.exports = __webpack_public_path__ + "static/media/WoodPanelType3.4fcd720b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WoodPanelType3.png
// module id = 1191
// module chunks = 0